var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version-12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A03",
    transform: "translate(-411.000000, -390.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-copy",
    transform: "translate(375.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account",
    transform: "translate(0.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0666667,36.5126064 C53.0648554,37.1230322 53.0648554,37.7352856 53.063044,38.3457113 C53.063044,38.4352648 53.0485536,38.5248183 53.0213839,38.6070613 C52.9724786,38.7550987 52.8819131,38.8775493 52.7714232,38.9433437 C52.7279518,38.970758 52.6808578,38.9872066 52.6337637,38.9963448 C52.6192732,38.9981724 52.6047828,39 52.5921036,39 L52.5667453,39 L37.4296321,39 C37.4151416,39 37.4006512,39 37.3861607,38.9981724 C37.335444,38.9926895 37.2847274,38.9780685 37.2376333,38.9506542 C37.1235208,38.8866874 37.0275214,38.7624091 36.9768048,38.6107165 C36.9496351,38.5339564 36.936956,38.4517134 36.9333333,38.3694704 L36.9333333,38.3365732 L36.9333333,36.1872897 L36.9333333,32.888432 C37.6071405,30.6093873 41.157307,30.2 42.5465813,30.2 L47.3628532,30.2 C48.7521275,30.2 52.40735,31.09919 53.0340631,32.9743302 L53.0666667,36.5126064 L53.0666667,36.5126064 Z M44.9990149,17 C47.8360903,17 50.1333333,19.2972867 50.1333333,22.1333333 C50.1333333,24.96938 47.8360903,27.2666667 44.9990149,27.2666667 C42.1639097,27.2666667 39.8666667,24.96938 39.8666667,22.1333333 C39.8666667,19.2972867 42.1639097,17 44.9990149,17 L44.9990149,17 Z",
    id: "ic/account"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon_account.52961ade79aa110fe38ff80dd0e97350.svg";
export { ForwardRef as ReactComponent };